import { ExternalLinkFilledIcon } from '@mr-yum/frontend-ui'
import { IconCard } from 'components/Common/IconCard'
import React from 'react'

export const PassAppCTA = ({ onClick }: { onClick: () => void }) => {
  const PassAppLogo = (
    <img
      className="h-full w-full"
      src="/static/avc/the-pass-iOS-1024.jpg"
      alt=" Pass App logo"
    />
  )

  return (
    <div className="space-y-5 px-4 py-5">
      <h3 className="my-heading-sm">Get rewards</h3>
      <IconCard
        icon={PassAppLogo}
        heading="$10 off your first order"
        description="Earn points & more with The Pass"
        showIndicator={true}
        indicatorIcon={<ExternalLinkFilledIcon className="mr-0.5" />}
        href={'https://l.ead.me/AVCApp'}
        onClick={onClick}
        target="_blank"
      />
    </div>
  )
}
